<script setup lang="ts">
import * as echarts from 'echarts/core'
import { BarChart, LineChart } from 'echarts/charts'
import { GridComponent, TooltipComponent, TitleComponent, LegendComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { ref, watch, nextTick, onBeforeUnmount } from 'vue'
import { useResizeObserver } from '@vueuse/core'
import type { ECharts } from 'echarts/core'

// Register once
echarts.use([
	  CanvasRenderer,
	  BarChart,
	  LineChart,
	  GridComponent,
	  TooltipComponent,
	  TitleComponent,
	  LegendComponent
	])

const props = defineProps<{
	  options: any
	  theme?: string
	  manualUpdate?: boolean
}>()
console.log(props.options)
const chartRef = ref<HTMLElement | null>(null)
const chartInstance = ref<ECharts | null>(null)

// Resize chart
const { stop: stopResizeObserver } = useResizeObserver(chartRef, () => {
	  chartInstance.value?.resize()
})

// Helper: Validate options
function isValidOptions(options: any): boolean {
	  return options &&
		    options.xAxis?.data?.length &&
		    Array.isArray(options.series) &&
		    options.series.length > 0 &&
		    options.series[0].data?.length
}

// Init chart safely
async function tryInitChart(options: any) {
	  if (!chartRef.value || chartInstance.value || !isValidOptions(options)) return

	  await nextTick() // Wait until DOM updates
	  const rect = chartRef.value.getBoundingClientRect()
	  if (rect.width === 0 || rect.height === 0) return // Wait until visible

	  chartInstance.value = echarts.init(chartRef.value, props.theme)
	  chartInstance.value.setOption(options)
}

await nextTick() // Wait until DOM updates
setTimeout(() => {
	  chartInstance.value?.resize()
}, 100)
// Watch for changes to options
watch(
	  () => props.options,
	  async (newOptions) => {
		  console.log(props.options)
		      if (!isValidOptions(newOptions)) return

		      if (chartInstance.value && !props.manualUpdate) {
			            chartInstance.value.setOption(newOptions)
			          } else {
					        await tryInitChart(newOptions)
					      }
		    },
	  { immediate: true, deep: true }
	)

onBeforeUnmount(() => {
	  stopResizeObserver()
	  chartInstance.value?.dispose()
	  chartInstance.value = null
})
</script>

<template>
	  <div ref="chartRef" class="w-full h-full"  style="min-height: 300px;" />
</template>

